import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import AppRoutes from "./routes";
import { ApplicantsProvider } from "./context/ApplicantsContext";
import ReactGA from "react-ga4";
import { baseTheme } from "./theme";
import { geekTheme } from "./theme/index";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { stopAllVideos } from "./hooks/useVideoCleanup";

const GA_MEASUREMENT_ID = process.env.REACT_APP_ANALYTICS_MEASURMENT_ID;
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

if (!STRIPE_PUBLIC_KEY) {
  throw new Error("Missing STRIPE_PUBLIC_KEY in environment variables");
}

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function VideoCleanupListener() {
  const location = useLocation();

  useEffect(() => {
    // Stop all videos whenever the route changes
    stopAllVideos();
  }, [location.pathname]);

  return null;
}


function App() {
  const isHiring = window.location.pathname.includes("/hiring");
  const theme = isHiring ? geekTheme : baseTheme; 

  return (
    <CssVarsProvider theme={theme} defaultColorScheme="light">
      <BrowserRouter>
        <GAListener />
        <VideoCleanupListener />
        <ApplicantsProvider>
          <Elements stripe={stripePromise}>
            <AppRoutes />
          </Elements>
        </ApplicantsProvider>
      </BrowserRouter>
    </CssVarsProvider>
  );
}

export default App;
